"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalAggregateReportResponseToJSON = exports.InternalAggregateReportResponseFromJSONTyped = exports.InternalAggregateReportResponseFromJSON = exports.instanceOfInternalAggregateReportResponse = void 0;
var runtime_1 = require("../runtime");
var InternalAggregateReportRow_1 = require("./InternalAggregateReportRow");
var TimeDimensionType_1 = require("./TimeDimensionType");
/**
 * Check if a given object implements the InternalAggregateReportResponse interface.
 */
function instanceOfInternalAggregateReportResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfInternalAggregateReportResponse = instanceOfInternalAggregateReportResponse;
function InternalAggregateReportResponseFromJSON(json) {
    return InternalAggregateReportResponseFromJSONTyped(json, false);
}
exports.InternalAggregateReportResponseFromJSON = InternalAggregateReportResponseFromJSON;
function InternalAggregateReportResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'continuationToken': !(0, runtime_1.exists)(json, 'continuation_token') ? undefined : json['continuation_token'],
        'reportStart': !(0, runtime_1.exists)(json, 'report_start') ? undefined : (new Date(json['report_start'])),
        'reportEnd': !(0, runtime_1.exists)(json, 'report_end') ? undefined : (new Date(json['report_end'])),
        'granularity': !(0, runtime_1.exists)(json, 'granularity') ? undefined : (0, TimeDimensionType_1.TimeDimensionTypeFromJSON)(json['granularity']),
        'rows': !(0, runtime_1.exists)(json, 'rows') ? undefined : (json['rows'].map(InternalAggregateReportRow_1.InternalAggregateReportRowFromJSON)),
        'warnings': !(0, runtime_1.exists)(json, 'warnings') ? undefined : json['warnings'],
    };
}
exports.InternalAggregateReportResponseFromJSONTyped = InternalAggregateReportResponseFromJSONTyped;
function InternalAggregateReportResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'continuation_token': value.continuationToken,
        'report_start': value.reportStart === undefined ? undefined : (value.reportStart.toISOString()),
        'report_end': value.reportEnd === undefined ? undefined : (value.reportEnd.toISOString()),
        'granularity': (0, TimeDimensionType_1.TimeDimensionTypeToJSON)(value.granularity),
        'rows': value.rows === undefined ? undefined : (value.rows.map(InternalAggregateReportRow_1.InternalAggregateReportRowToJSON)),
        'warnings': value.warnings,
    };
}
exports.InternalAggregateReportResponseToJSON = InternalAggregateReportResponseToJSON;
